var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReAssignAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07503 14.85H11V13.5666H9.07503C8.01372 13.5666 7.15003 12.703 7.15003 11.6416C7.15003 10.5803 8.01372 9.71663 9.07503 9.71663H12.925V11.6416L16.1334 9.07497L12.925 6.5083V8.4333H9.07503C7.30596 8.4333 5.8667 9.87256 5.8667 11.6416C5.8667 13.4107 7.30596 14.85 9.07503 14.85Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReAssignAction);
export default __webpack_public_path__ + "static/media/ReAssignAction.39a84969b2e9afdc23557309d4a6255a.svg";
export { ForwardRef as ReactComponent };